import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  continueBtn: {
    id: 'FL1U2n',
    defaultMessage: 'Upload & Preview',
    description: 'A button that allows you to go to the next step of the import process',
  },
});
